import axios from 'axios';

export const state = {
  assets: [],
  assetsPagination: {},
  loading: false,
};

export const mutations = {
  setAssets(context, assets) {
    context.assets = assets;
    context.loading = false;
  },

  setAssetsPagination(context, pagination) {
    context.assetsPagination = pagination;
    context.loading = false;
  },

  setLoading(context, value) {
    context.loading = value;
  },
};

export const actions = {
  async getAssets({ commit, rootState }, query) {
    try {
      const { jwtToken } = rootState.userStore.user.signInUserSession.idToken;
      const options = {
        headers: {
          Authorization: jwtToken,
        },
      };

      commit('setLoading', true);

      const assets = await axios.get(`${window.BASE_API.BAADER}/assets?${query}`, options)
        .then(response => response.data);

      commit('setAssets', assets.data);
      commit('setAssetsPagination', assets.pagination);
      commit('setLoading', false);
    } catch (err) {
      commit('setLoading', false);
    }
  },
  async blockAsset(context, data) {
    return axios
      .post(`${window.BASE_API.BAADER}/assets/block`, data)
      .catch(error => Promise.reject(error));
  },
  async removeBlock(context, wpnr) {
    return axios
      .delete(`${window.BASE_API.BAADER}/assets/remove-block/${wpnr}`)
      .catch(error => Promise.reject(error));
  },
};

const assetsStore = {
  state,
  mutations,
  actions,
};

export default assetsStore;



// WEBPACK FOOTER //
// ./src/store/baader/assetsStore.js